import i18next from 'i18next';
import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { AuthApi } from '../../api/authApi';
import css from '../../css/signin/signIn.module.scss';
import { ReactComponent as AppleBadge } from '../../img/signin/Download_on_the_App_Store_Badge_JP_RGB_blk_100317.svg';
import GoogleBadge from '../../img/signin/google-play-badge.png';
import { ReactComponent as Logo } from '../../img/signin/logo.svg';
import { ReactComponent as TwitterLogo } from '../../img/signin/twitter.svg';
import { selectError, setSigninError } from '../../slice/errorSlice';
import { SendLoginEvent } from '../../utils/gtag';

export const SignIn: React.FC = () => {
    const dispatch = useDispatch();
    const loginHandler = async () => {
        try {
            SendLoginEvent('twitter');
            window.location.href = await AuthApi.twitterAuth();
        } catch (_) {
            dispatch(setSigninError(i18next.t('error.login')));
        }
    };

    const { signinError } = useSelector(selectError);

    return (
        <div className={css.wrapper}>
            <div className={css.content}>
                <Logo height="64" width="275" />
                <h1 className={css.login}>ログイン</h1>
                <div onClick={loginHandler} className={css.twitterButton}>
                    <TwitterLogo height="16" width="20" />
                    <span>Twitterログイン</span>
                </div>
                {signinError !== null && <p className={css.err}>{signinError}</p>}
                <p className={css.twitterMemo}>※Twitterログインのみ対応</p>
                <hr />
                <h1 className={css.signup}>新規登録</h1>
                <p className={css.signupMemo}>新規登録の場合はスマホアプリより登録をお願いします</p>
                <div className={css.app}>
                    <a href="https://itunes.apple.com/jp/app/id1453661819">
                        <AppleBadge height="48" width="132" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.reactcorp.cocalero">
                        <img src={GoogleBadge} alt="Google Playで手に入れよう" className={css.googleBadge} />
                    </a>
                </div>
            </div>
        </div>
    );
};
